export default "__VITE_ASSET__260f7cef__"